export const Colors = {
  green: "#00b82e",
  green1: "#333D29",
  green2: "#656D4A",
  green3: "#414833",
  green4: "#304529",
};
